import React, { memo } from 'react';
import { ValidationErrors } from 'constants/validations';
import { useCountryDetailsEdit } from './useCountryDetailsEdit';
import { Col, Form, FormModal, LanguageSelect, Row, Select, TagSelect, Input } from 'components';

const { TextArea } = Input;

export interface ICountryDetailsUpdate {
  onCancel: () => void;
  open?: boolean;
}

export const CountryDetailsEdit = memo<ICountryDetailsUpdate>((props) => {
  const [form] = Form.useForm();
  const { onCancel, open } = props;

  const {
    onFinish,
    regions,
    subRegions,
    contextHolder,
    tagData,
    isSaveBtnDisabled,
    checkErrors,
    onCancelModal,
    isLoading,
  } = useCountryDetailsEdit({
    onCancel,
    form,
    open,
  });

  return (
    <>
      {contextHolder}
      <FormModal
        form={form}
        title={'Update Country Details'}
        okText={'Save'}
        open={open}
        isLoading={isLoading}
        disableOkBtn={isSaveBtnDisabled}
        onValuesChange={checkErrors}
        onCancel={onCancelModal}
        onSubmit={onFinish}
      >
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item name="regionIds" label={'Region'}>
              <Select mode={'multiple'} maxTagCount={'responsive'} options={regions} size={'large'} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="subRegions" label={'Sub-Region'}>
              <Select mode={'multiple'} maxTagCount={'responsive'} options={subRegions} size={'large'} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="languageIds"
              rules={[{ required: true, message: ValidationErrors.required('Language') }]}
              label={'Language*'}
            >
              <LanguageSelect mode={'multiple'} maxTagCount={'responsive'} size={'large'} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <TagSelect data={tagData} name={'tags'} label={'Tags'} />
          </Col>
          <Col span={24}>
            <Form.Item label={'Additional Notes'} name={'additionalNotes'}>
              <TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>
      </FormModal>
    </>
  );
});
